import React, { useMemo } from "react";

import Paragraph from "antd/es/typography/Paragraph";

import Email from "@mapmycustomers/shared/types/email/Email";

import SearchTextHighlighter from "@app/component/EntityEmails/components/SearchTextHighlighter";
import removeThreadFromEmailHtml from "@app/component/EntityEmails/util/removeThreadFromEmailHtml";
import sanitizeEmailHtml from "@app/component/EntityEmails/util/sanitizeEmailHtml";

import isExternalEmail from "../util/isExternalEmail";

interface ParentEmailBodyPreviewProps {
  className?: string;
  email: Email;
}

const ParentEmailBodyPreview: React.FC<ParentEmailBodyPreviewProps> = ({ className, email }) => {
  const emailBodyText = useMemo(() => {
    const emailBodyHtml = isExternalEmail(email) ? sanitizeEmailHtml(email.body) : email.body;
    const [emailBodyWithThreadHtml] = removeThreadFromEmailHtml(emailBodyHtml);
    return emailBodyWithThreadHtml.innerText;
  }, [email]);

  return (
    <div className={className}>
      <Paragraph
        ellipsis={{
          expandable: false,
          rows: 1,
        }}
      >
        <SearchTextHighlighter text={emailBodyText} />
      </Paragraph>
    </div>
  );
};

export default ParentEmailBodyPreview;
